import { CancelPresentation } from "@mui/icons-material";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface GaiaGridOverlayProps {
    children: React.ReactNode;
}

function GaiaGridOverlay({ children }: GaiaGridOverlayProps) {
    return (
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="100%">
            {children}
        </Box>
    );
}

export function NoRowsOverlay() {
    const { t } = useTranslation("app");
    return (
        <GaiaGridOverlay>
            <CancelPresentation sx={{ width: 64, height: 64 }} />
            <Typography>{t("gaiaGridOverlay.noResults")}</Typography>
        </GaiaGridOverlay>
    );
}

export function LoadingOverlay() {
    return (
        <GaiaGridOverlay>
            <CircularProgress />
        </GaiaGridOverlay>
    );
}

interface ErrorOverlayProps {
    error: unknown;
}

export function ErrorOverlay({ error }: ErrorOverlayProps) {
    return error instanceof Error ? (
        <GaiaGridOverlay>
            <Typography>{error.message}</Typography>
        </GaiaGridOverlay>
    ) : (
        <GaiaGridOverlay>
            <Typography>Something went wrong</Typography>
        </GaiaGridOverlay>
    );
}
